import Link from 'next/link';
import { createContext, PropsWithChildren, useContext } from 'react';

import { WithLinkFactory } from './types';

export type TopNavigationContextType = WithLinkFactory<{
  content: {
    currency: string;
    language: string;
    logout: string;
    profile: string;
  };
}>;

const TopNavigationContext = createContext<TopNavigationContextType>({} as unknown as TopNavigationContextType);

export type TopNavigationProviderProps = PropsWithChildren<{
  content: TopNavigationContextType['content'];
  linkFactory?: TopNavigationContextType['linkFactory'] | undefined;
}>;

const defaultNextLinkFactory: TopNavigationContextType['linkFactory'] = (props) => <Link {...props} />;

export const TopNavigationProvider = ({
  children,
  linkFactory = defaultNextLinkFactory,
  ...context
}: TopNavigationProviderProps) => (
  <TopNavigationContext.Provider
    value={{
      ...context,
      linkFactory,
    }}
  >
    {children}
  </TopNavigationContext.Provider>
);

export const useTopNavigation = () => useContext(TopNavigationContext);
export const useContent = () => useContext(TopNavigationContext).content;
